import { Entitlements, hasAdminEntitlement } from '@/ifaces/entitlements';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import { t } from '@lingui/core/macro';
import { ChartColumnBig, Wrench } from 'lucide-react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { useBodyScroll } from '../hooks/use-body-scroll';
import { useEntitlements } from '../hooks/use-custom-events';
import { LanguageSwitcher } from './LanguageSwitcher';
import { Logo } from './Logo';
import { TutorAvatar } from './TutorAvatar';

export function Header() {
  const [entitlements, setEntitlements] = useState<Entitlements>();
  useEntitlements({ onSet: (entitlements) => setEntitlements(entitlements) });
  const { direction, amount } = useBodyScroll();
  const navigate = useNavigate();

  const hideNavbar = direction === 'down' && amount > 10;
  const navbarClassName = `navbar ${hideNavbar ? 'hidden' : ''}`;
  const headerClassName = amount < 10 ? '' : 'shadow';

  return (
    <header className={headerClassName}>
      <SignedOut>
        <div className={navbarClassName}>
          <Link to="/" className="flex items-center px-4">
            <TutorAvatar size={40} noBeta />
          </Link>
        </div>
      </SignedOut>
      <SignedIn>
        <div className="flex flex-col">
          <div className={navbarClassName}>
            <Link to="/" className="flex items-center px-4">
              <Logo height={34} width="fit-content" color="var(--text-base)" />
            </Link>
            <div id="header-insert-div" />
            <div className="flex gap-4 items-center">
              <div className="language-switcher">
                <LanguageSwitcher />
              </div>
            </div>
            <div className="flex items-center pl-3">
              {entitlements && (
                <UserButton userProfileUrl="/profile">
                  <UserButton.MenuItems>
                    {(entitlements.can_view_reports || entitlements.can_view_user_reports) && (
                      <UserButton.Action
                        label={t`Progress Dashboard`}
                        labelIcon={<ChartColumnBig size={16} />}
                        onClick={() => navigate('/reporting/progress')}
                      />
                    )}
                    {hasAdminEntitlement(entitlements) && (
                      <UserButton.Link
                        label={t`Admin Panel`}
                        labelIcon={<Wrench size={16} />}
                        href="/_sys/"
                      />
                    )}
                  </UserButton.MenuItems>
                </UserButton>
              )}
            </div>
          </div>
        </div>
        <div id="header-insert-progress-tracker" />
      </SignedIn>
    </header>
  );
}
